<template id="arcgisCPT">
  <div :id="gisId" :style="mapStyle" class="cpt_map">
    <div
      class="popupBox"
      :style="popupBoxOption.popupBoxStyle + popupBoxOption.userDiyBoxStyle"
      v-show="popupBoxOption.usePopupBox"
      v-html="popupBoxOption.popupBoxContent"
    ></div>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";

export default {
  props: ["value"],
  data() {
    return {
      gisId: "map",
      mapStyle: "width:600px;height:400px",
      mapServerURL: "",
      mapExtent: {},
      pointLayerList: [],
      lineLayerList: [],
      areaLayerList: [],
      g_gisCPT: {},
      arc_map: {},
      arc_view: {},
      mapOption: {
        mapId: "map",
        gisURL: "https://js.arcgis.com/4.17/",
        gisCss: "https://js.arcgis.com/4.17/esri/themes/light/main.css",
        f1: "http://58.59.100.238:6080/arcgis/rest/services/mapkpi/MapServer",
        spatialReference: {
          wkid: 102100,
        },
        graphicsLayerList: null,
        graphic: null,
        zoom: 12,
        center: [13121392.94110617, 4491382.63653429],
        addOSM: false,
        useTile: false,
        useProxy: false,
        proxyUrl: "",
        proxyHostUrl: "",
      },
      layerClickCb: null,
      popupBoxOption: {
        usePopupBox: false,
        popupBoxStyle: "left:0;top:0;",
        userDiyBoxStyle: "",
        popupBoxContent: "",
        popupHeight: 100,
        popupWidth: 100,
      },
      popupMapPoint: {},
    };
  },
  methods: {
    //转换得到数值
    getNumber: function (testNumber, minValue, maxValue) {
      let lastNumber = maxValue;
      if (!testNumber) return lastNumber;
      if (!isNaN(testNumber)) {
        if (testNumber >= minValue && testNumber <= maxValue) return testNumber;
      }
      return lastNumber;
    },
    //地图初始化
    mapInit: function () {
      let self = this;

      //js初始化地图
      self.mapInitOfGISServer(function (m, v) {
        //判断是否需要注册图层点击事件
        self.$emit("initLoad", m, v);
        //地图view 地图拖拽和鼠标滚轮事件
        v.on(["mouse-wheel", "drag"], function () {
          //self.popupMapPoint=ev.mapPoint;
          self.setPopupScreenPoint();
        });
        //地图上点击事件注册 关闭窗口
        self.entrustFunOnMapClick(self.closeWindow);
      });
    },
    //关闭窗口
    closeWindow: function () {
      this.popupBoxOption.usePopupBox = false;
    },
    //渲染撒点
    renderPoint: function () {
      let self = this;
      //清除point图层
      for (var i = 0; i < self.pointLayerList.length; i++) {
        var item = self.pointLayerList[i];
        self.destoryLayer(item);
      }
      self.pointLayerList = [];

      //处理点图层集合
      for (var i = 0; i < self.value.pointOptions.length; i++) {
        var pointOption = self.value.pointOptions[i];
        if (!pointOption.visible) continue;
        self.createLayer(pointOption.layerName);
        self.pointLayerList.push(pointOption.layerName);
        var useImg = pointOption.useImg;
        if (useImg) {
          self.drawPointOfImg(
            pointOption.layerName,
            pointOption.pointList,
            pointOption.imgPath,
            pointOption.imgWidth,
            pointOption.imgHeight,
            pointOption.popupBoxOption
          );
        } else {
          self.drawPoint(
            pointOption.layerName,
            pointOption.pointList,
            pointOption.color,
            pointOption.size,
            pointOption.popupBoxOption
          );
        }
      }
    },
    //渲染画线
    renderLine: function () {
      let self = this;
      //清除point图层
      for (var i = 0; i < self.lineLayerList.length; i++) {
        var item = self.lineLayerList[i];
        self.destoryLayer(item);
      }
      self.lineLayerList = [];

      //处理点图层集合
      for (var i = 0; i < self.value.lineOptions.length; i++) {
        var lineOption = self.value.lineOptions[i];
        if (!lineOption.visible) continue;
        self.createLayer(lineOption.layerName);
        self.lineLayerList.push(lineOption.layerName);
        self.drawLine(
          lineOption.layerName,
          lineOption.lineList,
          lineOption.color,
          lineOption.size,
          lineOption.popupBoxOption
        );
      }
    },
    renderArea: function () {
      let self = this;
      //清除point图层
      for (var i = 0; i < self.areaLayerList.length; i++) {
        var item = self.areaLayerList[i];
        self.destoryLayer(item);
      }
      self.areaLayerList = [];

      //处理点图层集合
      for (var i = 0; i < self.value.areaOptions.length; i++) {
        var areaOption = self.value.areaOptions[i];
        if (!areaOption.visible) continue;
        self.createLayer(areaOption.layerName);
        self.areaLayerList.push(areaOption.layerName);
        self.drawArea(
          areaOption.layerName,
          areaOption.areaList,
          areaOption.bgColor,
          areaOption.borderColor,
          areaOption.borderWidth,
          areaOption.popupBoxOption
        );
      }
    },
    //使用gis服务初始化地图
    mapInitOfGISServer: function (cb) {
      var gisServerURL = this.mapServerURL;
      if (this.gisId) {
        this.mapOption.mapId = this.gisId;
      }
      let options = {
        url: this.mapOption.gisURL,
        css: this.mapOption.gisCss,
      };

      let self = this;

      loadModules(
        [
          "esri/Map",
          "esri/Basemap",
          "esri/views/MapView",
          "esri/layers/MapImageLayer",
          "esri/layers/GraphicsLayer",
          "esri/Graphic",
          "esri/geometry/Point",
          "esri/symbols/TextSymbol",
          "esri/symbols/support/jsonUtils",
          "esri/geometry/Extent",
          "esri/tasks/GeometryService",
          "esri/geometry/SpatialReference",
          "esri/tasks/support/ProjectParameters",
          "esri/layers/OpenStreetMapLayer",
          "esri/layers/TileLayer",
          "esri/config",
          "esri/core/urlUtils",
        ],
        options
      ).then(
        ([
          Map,
          Basemap,
          MapView,
          MapImageLayer,
          GraphicsLayer,
          Graphic,
          Point,
          TextSymbol,
          jsonUtils,
          Extent,
          GeometryService,
          SpatialReference,
          ProjectParameters,
          OpenStreetMapLayer,
          TileLayer,
          esriConfig,
          urlUtils,
        ]) => {
          self.arc_map = new Map();

          //debugger;
          if(self.mapOption.useProxy){
            urlUtils.addProxyRule({
              urlPrefix: self.mapOption.proxyHostUrl,
              proxyUrl: self.mapOption.proxyUrl,
            });
          }

          self.mapOption.graphicsLayer = GraphicsLayer;
          self.mapOption.graphic = Graphic;
          //debugger;
          if (self.mapOption.addOSM) {
            //利用url创建一个动态地图服务对象
            var osm_layer = new OpenStreetMapLayer();
            //将地图服务对象添加到地图容器中
            self.arc_map.add(osm_layer);
          }

          if (gisServerURL) {
            if (self.mapOption.useTile) {
              var layer = new TileLayer({
                url: gisServerURL,
              });
              //将地图服务对象添加到地图容器中
              self.arc_map.add(layer);
            } else {
              //利用url创建一个动态地图服务对象
              var layer = new MapImageLayer(gisServerURL);
              //将地图服务对象添加到地图容器中
              self.arc_map.add(layer);
            }
          }

          var view = new MapView({
            map: self.arc_map,
            container: self.mapOption.mapId,
            spatialReference: self.mapOption.spatialReference
          });

          if (self.mapOption.addOSM) {
            var pt = new Point({
              x: self.mapOption.center[0],
              y: self.mapOption.center[1],
              spatialReference: self.mapOption.spatialReference,
            });
            view.center = pt;
            view.zoom = self.mapOption.zoom;
          } else {
            //view.scale = 250000
          }

          //设置隐藏底部copyrights信息
          view.ui.remove("attribution");

          //删除默认缩放按钮
          view.ui.remove("zoom");
          //view.extent = new Extent(self.mapExtent);

          self.arc_view = view;

          cb(self.arc_map, self.arc_view);
        }
      );
    },
    //使用点样式-画点
    drawPoint: function (
      graphicLayerId,
      xyList,
      color,
      pixel,
      popupBoxOption,
      visible,
      selectOption
    ) {
      let self = this;
      var graphicLayer = self.arc_map.findLayerById(graphicLayerId);
      //判断图层是否为空
      if (!graphicLayer) return;
      graphicLayer.visible = visible;

      loadModules(["esri/Graphic"]).then(([Graphic]) => {
        var pointList = [];
        for (let index = 0; index < xyList.length; index++) {
          const element = xyList[index];
          var point = {
            type: "point",
            spatialReference: self.mapOption.spatialReference,
            x: element.xy[0],
            y: element.xy[1],
          };

          var symbol = {
            type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
            color: color,
            size: pixel,
            outline: {
              // autocasts as new SimpleLineSymbol()
              width: 0.5,
              color: color,
            },
          };

          var pointGraphic = new Graphic({
            geometry: point,
            symbol: symbol,
            attributes: element.attributes,
            popupBoxOption: popupBoxOption,
            selectOption: selectOption
          });

          pointList.push(pointGraphic);
        }
        if (pointList.length > 0) {
          graphicLayer.graphics.addMany(pointList);
        }
      });
    },
    //图标标记-画点
    drawPointOfImg: function (
      graphicLayerId,
      xyList,
      picUrl,
      imgWidth,
      imgHeight,
      popupBoxOption,
      visible,
      selectOption
    ) {
      let self = this;
      var graphicLayer = self.arc_map.findLayerById(graphicLayerId);
      
      //判断图层是否为空
      if (!graphicLayer) return;
      graphicLayer.visible = visible;

      loadModules(["esri/Graphic", "esri/symbols/support/jsonUtils"]).then(
        ([Graphic, jsonUtils]) => {
          var pointList = [];
          for (let index = 0; index < xyList.length; index++) {
            const element = xyList[index];
            var point = {
              type: "point",
              spatialReference: self.mapOption.spatialReference,
              x: element.xy[0],
              y: element.xy[1],
            };

            var symbol = jsonUtils.fromJSON({
              xoffset: 0,
              yoffset: 0,
              type: "esriPMS",
              url: picUrl,
              width: imgWidth,
              height: imgHeight,
            });

            var pointGraphic = new Graphic({
              geometry: point,
              symbol: symbol,
              attributes: element.attributes,
              popupBoxOption: popupBoxOption,
              selectOption: selectOption
            });

            pointList.push(pointGraphic);
          }
          if (pointList.length > 0) {
            graphicLayer.graphics.addMany(pointList);
          }
        }
      );
    },
    //注册地图点击事件
    entrustFunOnMapClick: function (cb) {
      let self = this;
      self.arc_view.on(["click"], function (event) {
        
        //点击事件
        self.arc_view.hitTest(event).then(function (response) {
          cb(event.mapPoint,response.results)
        })
      });
    },
    //全局注册图层点击事件
    entrustFunOnViewGraphicClick: function (cb) {
      let self = this;
      self.arc_view.on(["click"], function (event) {
        //点击事件
        self.arc_view.hitTest(event).then(function (response) {
          if (response.results.length > 0) {
            //读取点位信息
            var obj = response.results[0];
            //有弹窗，则设置弹窗属性
            if (obj.graphic.popupBoxOption) {
              if (obj.graphic.popupBoxOption.usePopupBox) {
                var option = obj.graphic.popupBoxOption;
                self.popupBoxOption.userDiyBoxStyle = option.userDiyBoxStyle;
                self.popupBoxOption.popupHeight = option.popupHeight;
                self.popupBoxOption.popupWidth = option.popupWidth;
                var content = self.translateStr(
                  option.popupBoxContent,
                  obj.graphic.attributes
                );
                //得到点位的attributes，替换他的所有属性值{xx}
                self.popupBoxOption.popupBoxContent = content;
                self.popupMapPoint = obj.mapPoint;
                self.setPopupScreenPoint();
                self.popupBoxOption.usePopupBox = true;
              }
            }
            cb(response.results[0], event, response);
          }
        });
      });
    },
    //字符串中的{xx}转换成对子中的obj.xx
    translateStr: function (str, obj) {
      var lastStr = str;
      for (let key in obj) {
        lastStr = lastStr.replace(new RegExp("{" + key + "}", "g"), obj[key]);
      }
      return lastStr;
    },
    //移动地图中心点位 direction=移动方向 上右下左 对应：1、2、3、4
    positionMap: function (direction, movePercent) {
      let self = this;

      //得到当前中心点位
      var centerX = self.arc_view.center.x;
      var centerY = self.arc_view.center.y;
      var sizeX = self.arc_view.size[0];
      var sizeY = self.arc_view.size[1];
      var pixWidth = (sizeX * 212.5) / 5;
      var pixHeight = (sizeY * 212.5) / 5;

      var moveX = (self.arc_view.scale / 160600) * pixWidth * movePercent;
      var moveY = (self.arc_view.scale / 160600) * pixHeight * movePercent;

      var direct = 1;
      direct = parseInt(direction);
      switch (direct) {
        case 1:
          centerY += moveY;
          break; //上
        case 2:
          centerX += moveX;
          break; //右
        case 3:
          centerY -= moveY;
          break; //下
        case 4:
          centerX -= moveX;
          break; //左
        default:
          centerY += moveY;
          break;
      }

      loadModules(["esri/geometry/Point"]).then(([Point]) => {
        //得到当前的scale
        var pt = new Point({
          x: centerX,
          y: centerY,
          spatialReference: self.mapOption.spatialReference,
        });
        self.arc_view.center = pt;
      });
    },
    //设置地图中心点
    setCenter: function (x, y) {
      let self = this;

      loadModules(["esri/geometry/Point"]).then(([Point]) => {
        var pt = new Point({
          x: x,
          y: y,
          spatialReference: self.mapOption.spatialReference,
        });
        self.arc_view.center = pt;
      });
    },
    //使用线样式-画线(支持多个线集合)
    drawLine: function (
      graphicLayerId,
      plineList,
      color,
      pixel,
      popupBoxOption
    ) {
      let self = this;
      var graphicLayer = self.arc_map.findLayerById(graphicLayerId);

      //判断图层是否为空
      if (!graphicLayer) return;

      loadModules(["esri/Graphic"]).then(([Graphic]) => {
        var lineList = [];
        for (let index = 0; index < plineList.length; index++) {
          const element = plineList[index];
          var polyline = {
            type: "polyline",
            paths: element.line,
            spatialReference: self.mapOption.spatialReference,
          };

          var symbol = {
            type: "simple-line", // autocasts as new SimpleMarkerSymbol()
            color: color,
            width: pixel,
          };

          var lineGraphic = new Graphic({
            geometry: polyline,
            symbol: symbol,
            attributes: element.attributes,
            popupBoxOption: popupBoxOption,
          });
          //graphicLayer.graphics.add(lineGraphic);
          lineList.push(lineGraphic);
        }
        if (lineList.length > 0) {
          graphicLayer.graphics.addMany(lineList);
        }
      });
    },
    //创建图层
    createLayer: function (layerId, layerIndex) {
      var zIndex = layerIndex ?? 100;
      let self = this;
      var graphicLayer = new self.mapOption.graphicsLayer({
        id: layerId,
        spatialReference: self.mapOption.spatialReference,
      });
      var h_graphicLayer = self.arc_map.findLayerById(layerId);
      if (!h_graphicLayer) self.arc_map.layers.add(graphicLayer, zIndex);
    },
    //隐藏图层
    hideLayer: function (graphicLayerId) {
      let self = this;
      var graphicLayer = self.arc_map.findLayerById(graphicLayerId);
      if (graphicLayer) {
        graphicLayer.visible = false;
      }
    },
    //显示图层
    showLayer: function (graphicLayerId) {
      let self = this;
      var graphicLayer = self.arc_map.findLayerById(graphicLayerId);
      if (graphicLayer) {
        graphicLayer.visible = true;
      }
    },
    //销毁图层
    destoryLayer: function (graphicLayerId) {
      let self = this;

      var graphicLayer = self.arc_map.findLayerById(graphicLayerId);
      if (graphicLayer) {
        self.arc_map.remove(graphicLayer);
        //.remove()
      }
    },
    hasLayer(graphicLayerId) {
      let self = this;

      var graphicLayer = self.arc_map.findLayerById(graphicLayerId);
      if (graphicLayer) {
        return true;
      }
      else
        return false;
    },
    //画面
    drawArea: function (
      graphicLayerId,
      pAreaList,
      areaColor,
      borderColor,
      borderWidth,
      popupBoxOption
    ) {
      let self = this;
      var graphicLayer = self.arc_map.findLayerById(graphicLayerId);

      //判断图层是否为空
      if (!graphicLayer) return;

      loadModules(["esri/Graphic"]).then(([Graphic]) => {
        var areaList = [];
        for (let index = 0; index < pAreaList.length; index++) {
          const element = pAreaList[index];
          var polygon = {
            type: "polygon",
            rings: element.area,
            spatialReference: self.mapOption.spatialReference,
          };

          var symbol = {
            type: "simple-fill", // autocasts as new SimpleMarkerSymbol()
            color: areaColor,
            style: "solid",
            outline: {
              // autocasts as new SimpleLineSymbol()
              color: borderColor,
              width: borderWidth,
            },
          };

          var areaGraphic = new Graphic({
            geometry: polygon,
            symbol: symbol,
            attributes: element.attributes,
            popupBoxOption: popupBoxOption,
          });
          //graphicLayer.graphics.add(lineGraphic);
          areaList.push(areaGraphic);
        }
        if (areaList.length > 0) {
          graphicLayer.graphics.addMany(areaList);
        }
      });
    },
    //创建并显示弹窗
    createAndShowPopup: function (mapPoint, content) {
      loadModules(["esri/widgets/Popup", "esri/geometry/Point"]).then(
        ([Popup, Point]) => {
          var self = this;
          var popup_user = new Popup(
            { offsetX: 5, offsetY: 0, titleInBody: false },
            domConstruct.create("div")
          );
          popup_user.setMap(self.arc_map);
          popup_user.resize(0, 0);
          popup_user.anchor = "right";
          popup_user.point = new Point(
            mapPoint.x,
            mapPoint.y,
            self.mapOption.spatialReference
          );
          popup_user.setContent(content);
          popup_user.show(mapPoint);
        }
      );
    },
    //设置弹出框在地图上的位置
    setPopupScreenPoint: function () {
      let self = this;
      if (!self.popupMapPoint.x) return;
      var popupMapPoint = self.arc_view.toScreen(self.popupMapPoint);
      var h = self.popupBoxOption.popupHeight;
      var w = self.popupBoxOption.popupWidth;
      var x =
        popupMapPoint.x + 10 + w > self.arc_view.size[0]
          ? popupMapPoint.x - 10 - w
          : popupMapPoint.x + 10;
      var y =
        popupMapPoint.y + 10 + h > self.arc_view.size[1]
          ? popupMapPoint.y - 10 - h
          : popupMapPoint.y + 10;
      self.popupBoxOption.popupBoxStyle = "top:" + y + "px;left:" + x + "px;";
    },
    //放大
    zoomIn() {
      var self = this;
      //debugger;
      var zoom = self.arc_view.zoom;
      var scale = self.arc_view.scale;
      zoom--;
      scale -= 20000;
      if(self.mapOption.useTile){
        if (zoom != -1) {
          self.arc_view.zoom = zoom;
        }
      }
      else{
        if (scale >= 0) {
          self.arc_view.scale = scale;
        }
      }
      console.log(self.arc_view.zoom);
      console.log(self.arc_view.scale);
      // setTimeout(function () {
      //   self.setDiyPopupScreenPoint();
      // }, 200);
    },
    //设置缩放比例
    setScale(scale){
      var self = this;
      self.arc_view.scale=scale;
    },
    //缩小
    zoomOut() {
      var self = this;
      //debugger;
      var zoom = self.arc_view.zoom;
      var scale = self.arc_view.scale;
      zoom++;
      scale += 20000;
      if(self.mapOption.useTile){
        if (zoom != 13) {
          self.arc_view.zoom = zoom;
        }
      }
      else{
        if (scale <= 266666) {
        self.arc_view.scale = scale;
        }
      }
      console.log(self.arc_view.zoom);
      console.log(self.arc_view.scale);
      // setTimeout(function () {
      //   self.setDiyPopupScreenPoint();
      // }, 200);
    },
  },
  mounted() {
    let self = this;

    //设置地图的宽 高
    let mapHeight = this.getNumber(this.value.mapInfo.boxHeight, -1, 2800);
    let mapWidth = this.getNumber(this.value.mapInfo.boxWidth, -1, 4000);
    self.mapStyle =
      "width:" +
      (mapWidth == -1 ? "100%" : mapWidth + "px") +
      ";height:" +
      (mapHeight == -1 ? "100%" : mapHeight + "px");

    //设置地图的serverURL地址
    self.mapServerURL = this.value.mapInfo.serverURL;
    self.mapExtent = this.value.mapInfo.extent;

    //设置地图ID
    self.gisId = this.value.mapInfo.id;

    self.mapOption.center = this.value.mapInfo.center;
    self.mapOption.zoom = this.value.mapInfo.zoom;
    self.mapOption.spatialReference = this.value.mapInfo.extent.spatialReference;
    self.mapOption.addOSM = this.value.mapInfo.addOSM;
    self.mapOption.useTile = this.value.mapInfo.useTile;
    self.mapOption.useProxy = this.value.mapInfo.useProxy;
    self.mapOption.proxyUrl = this.value.mapInfo.proxyUrl;
    self.mapOption.proxyHostUrl = this.value.mapInfo.proxyHostUrl;

    self.mapInit();
  },
};
</script>

<style lang="scss" scoped>
/* 地图默认宽高 600 * 400 */
.cpt_map {
  width: 600px;
  height: 400px;
  position: relative;
  overflow: hidden;
}
.popupBox {
  position: absolute;
}
</style>